import React from "react";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import './SponsorsPage.css'

function SponsorsPage() {
    return <div className="SponsorsPage">
        <Navbar />
        <div className="organizers-page">
            <div className="organizers-container">
                <h2 className="organizers-title">Organized by:</h2>
                <div className="organizers-names">
                    <p>
                        <strong>Semiha Ergan</strong>, New York University<br />
                        <strong>Mario Berges</strong>, Carnegie Mellon University
                    </p>
                </div>
                <div className="organizers-email">
                    <p>For inquiries, please contact <a href="mailto:cue@nyu.edu">cue@nyu.edu</a></p>
                </div>
                <div className="logos-block">
                    <div className="institutions-logos">
                        <div className="logo-with-text">
                            <img src="/nyu-tandon-logo.jpg" alt="NYU Tandon School of Engineering" className="institution-logo tandon-logo" />
                            <p className="logo-text">Dept. of Civil, Urban, &amp; Environmental Engineering</p>
                        </div>
                        <img src="/cmu-colored.png" alt="Carnegie Mellon University College of Engineering" className="institution-logo cmu-logo" />
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </div>;
}

export default SponsorsPage;
